<template>
    <v-btn :height="props.height != null ? props.height :37" outlined color="transparent" class="border alternative-button py-0" elevation="0" :block="props.block" :to="{ name: props.to }" @click="props.click" >
        <div :class="`${props.textClass != undefined && props.textClass != '' ? props.textClass:'buttonTextDefault--text'}`" >
            <v-icon>{{props.icon}}</v-icon>
        </div>
       
    </v-btn>
</template>
<script>
    export default {
        name: 'alternativeButton',
        props: ['props']
    }
</script>

<style lang="scss">
    .alternative-button{
        min-width: 1rem !important;
        padding: 0.3125rem !important;

        &.btn {
            min-height: 3px !important;
            // max-height: 3px !important;

        }
    }

   

    .border{
        border: $lineColor-1 1px solid;
    }
</style>